<div class="content-wrapper" style="min-height: 1200.88px;  margin-left: 1%; margin-right: 1%;">
    <!-- Content Header (Page header) -->
    <section class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1>{{ "Convoyeur.Convoyeur" | translate }}</h1>
                </div>
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">
                        <li class="breadcrumb-item"><a href="#">{{ "FileAriane.Home" | translate }}</a></li>
                        <li class="breadcrumb-item "><a [routerLink]="['/convoyeur/all']">{{ "Convoyeur.Convoyeur" |
                                translate }}</a></li>
                        <li class="breadcrumb-item active">{{ "FileAriane.Detail" | translate }}</li>

                    </ol>
                </div>
            </div>
        </div><!-- /.container-fluid -->
    </section>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="container">
        <div class="container-fluid">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">

                        <div class="position-relative mb-4">
                            <!-- <div class="chartjs-size-monitor">
                                <div class="chartjs-size-monitor-expand">
                                    <div class=""></div>
                                </div>
                                <div class="chartjs-size-monitor-shrink">
                                    <div class=""></div>
                                </div>
                            </div> -->
                            <div class="col-sm-12">
                                <img style="height:400px; margin-left:40%" class="img-fluid" src="{{convoyeur?.avatar}}"
                                    alt="photo">
                            </div>

                        </div>

                    </div>
                </div>

            </div>
            <div class="row">

                <div class="col-lg-6">
                    <div class="card">
                        <div class="card-header border-0">
                            <h3 class="card-title">Information personnel</h3>

                        </div>
                        <div class="card-body table-responsive p-0">
                            <table class="table table-striped table-valign-middle">
                                <tbody>
                                    <tr>
                                        <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>
                                        <td>{{ "Convoyeur.nameLabel" | translate }}</td>
                                        <td style="color: rgb(0, 89, 255);">{{convoyeur?.name}}</td>
                                    </tr>
                                    <tr>
                                        <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                        <td>{{ "Convoyeur.emailLabel" | translate }}</td>
                                        <td style="color: rgb(0, 89, 255);">{{convoyeur?.email}}</td>
                                    </tr>
                                    <tr>
                                        <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                        <td>{{ "Convoyeur.CNI_numberLabel" | translate }}</td>
                                        <td style="color: rgb(0, 89, 255);">{{convoyeur?.CNI_number}}</td>
                                    </tr>
                                    <tr>
                                        <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                        <td>{{ "Convoyeur.picture_CNILabel" | translate }}</td>
                                        <td style="color: rgb(0, 89, 255);"><a
                                                href="{{convoyeur?.picture_CNI}}">Parcourir</a></td>
                                    </tr>
                                    <tr>
                                        <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                        <td>{{ "Convoyeur.sexeLabel" | translate }}</td>
                                        <td style="color: rgb(0, 89, 255);">{{convoyeur?.sexe}}</td>
                                    </tr>
                                    <tr>
                                        <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                        <td>{{ "Convoyeur.birth_dateLabel" | translate }}</td>
                                        <td style="color: rgb(0, 89, 255);">{{convoyeur?.birth_date}}</td>
                                    </tr>
                                    <tr>
                                        <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                        <td>{{ "Convoyeur.birth_placeLabel" | translate }}</td>
                                        <td style="color: rgb(0, 89, 255);">{{convoyeur?.birth_place}}</td>
                                    </tr>
                                    <tr>
                                        <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                        <td>{{ "Convoyeur.phone_number_1Label" | translate }}</td>
                                        <td style="color: rgb(0, 89, 255);">{{convoyeur?.phone_number_1}}</td>
                                    </tr>
                                    <tr>
                                        <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                        <td>{{ "Convoyeur.phone_number_2Label" | translate }}</td>
                                        <td style="color: rgb(0, 89, 255);">{{convoyeur?.phone_number_2}}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
                <div class="col-lg-6">
                    <div class="card">
                        <div class="card-header border-0">
                            <h3 class="card-title">Information personnel</h3>

                        </div>
                        <div class="card-body table-responsive p-0">
                            <table class="table table-striped table-valign-middle">
                                <tbody>
                                    <tr>
                                        <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                        <td>{{ "Convoyeur.marital_statusrLabel" | translate }}</td>
                                        <td style="color: rgb(0, 89, 255);">{{convoyeur?.marital_status}}</td>
                                    </tr>
                                    <tr>
                                        <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                        <td>{{ "Convoyeur.childrenLabel" | translate }}</td>
                                        <td style="color: rgb(0, 89, 255);">{{convoyeur?.children}}</td>
                                    </tr>
                                    <tr>
                                        <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                        <td>{{ "Convoyeur.residence_townLabel" | translate }}</td>
                                        <td style="color: rgb(0, 89, 255);">{{convoyeur?.residence_town}}</td>
                                    </tr>
                                    <tr>
                                        <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                        <td>{{ "Convoyeur.contact_personLabel" | translate }}</td>
                                        <td style="color: rgb(0, 89, 255);">{{convoyeur?.contact_person}}</td>
                                    </tr>
                                    <tr>
                                        <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                        <td>{{ "Convoyeur.emergency_phoneLabel" | translate }}</td>
                                        <td style="color: rgb(0, 89, 255);">{{convoyeur?.emergency_phone}}</td>
                                    </tr>
                                    <tr>
                                        <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                        <td>{{ "Convoyeur.adressLabel" | translate }}</td>
                                        <td style="color: rgb(0, 89, 255);">{{convoyeur?.adress}}</td>
                                    </tr>


                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>

                <!-- /.col-md-6 -->
            </div>

            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header border-0">
                        <h3 class="card-title">Information Permis</h3>
                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-striped table-valign-middle">
                            <tbody>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Convoyeur.LicenceNumberLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{convoyeur?.licence_number}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Convoyeur.LicenceTypeLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{convoyeur?.licence_type}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Convoyeur.EndDateLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);">{{convoyeur?.end_of_date}}</td>
                                </tr>
                                <tr>
                                    <td class="mailbox-star"><a><i class="fas fa-star text-warning"></i></a></td>

                                    <td>{{ "Convoyeur.LicenceValidityFileLabel" | translate }}</td>
                                    <td style="color: rgb(0, 89, 255);"><a
                                            href="{{convoyeur?.licence_validity_file}}">Parcourir</a></td>
                                </tr>
                                <!-- <tr>
                                    <td>Avez-vous une formation autre que le permis?</td>

                                    <th>Oui</th>
                                    <th>Non</th>

                                </tr> -->
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
</div>